<template>
  <div class="content_li" :class="{ isactive: rowactive == option.channelId }">
    <div class="main_left">
      <span
        :class="{
          title_num1: (index + 1) % 4 == 1,
          title_num2: (index + 1) % 4 == 2,
          title_num3: (index + 1) % 4 == 3,
          title_num4: (index + 1) % 4 == 0
        }"
      >{{ index + 1 }}</span>
    </div>
    <div class="main_middle">
      <p class="course_title">{{ option.name }}</p>
      <p class="course_time">{{ parseInt(option.duration / 60) }}分钟</p>
    </div>
    <div class="main_right">
      <div
        v-if="(!option.bought) && (!option.previewVideo) && (!alldata.free)"
        class="main_right_img"
      >
        <img src="images/course/buycan.png" alt />
      </div>
      <button v-if="option.previewVideo&&(!alldata.free) && !option.bought" class="video_btn">可试看</button>
      <div v-if="option.bought&&(!alldata.free)" class="circle-chart">
        <div class="wrapper">
          <div class="all_circle" v-if="this.option.playtime / this.option.duration == 1"></div>
          <svg v-else>
            <path :d="dashOffset" fill="#22ac38" />
          </svg>
        </div>
      </div>
      <p class="main_right_time" v-if="alldata.free">{{ option.viewQuantity }}次播放</p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "progressCircle",
  props: {
    radius: {
      type: String,
      default: "0.32rem"
    },
    percent: {
      type: Number,
      default: 0
    },
    option: {},
    index: {},
    alldata: {},
    rowactive: {
      type: String
    }
  },
  data() {
    return {
      dashArray: [Math.PI * 100]
    };
  },
  computed: {
    dashOffset() {
      var xx =
        20 +
        Math.sin((this.option.playtime / this.option.duration) * Math.PI * 2) *
          20;

      var yy =
        20 -
        Math.cos((this.option.playtime / this.option.duration) * Math.PI * 2) *
          20;
      var big = 0;
      if (this.option.playtime / this.option.duration > 0.5) {
        big = 1;
      }
      return (
        "M " +
        20 +
        "," +
        20 +
        " L " +
        20 +
        "," +
        0 +
        " A " +
        20 +
        "," +
        "20 0 " +
        big +
        " 1 " +
        xx +
        " " +
        yy +
        " Z"
      );
    }
  }
};
</script>

<style scoped>
.wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e6e6e6;
  position: relative;
}
.all_circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #22ac38;
  position: absolute;
}
svg {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
}
.content_li {
  width: 7.15rem;
  height: 1.1rem;
  padding: 0.28rem 0.17rem;
  border-bottom: 1px solid #efefef;
  margin: 0 auto;
}
.main_left {
  float: left;
  padding: 0.25rem 0;
  width: 0.6rem;
  height: 0.6rem;
}
.main_left span {
  float: left;
  width: 0.6rem;
  height: 0.6rem;
  line-height: 0.6rem;
  border-radius: 50%;
  font-size: 0.35rem;
  color: #ffffff;
}
.main_left .title_num1 {
  background-color: #f56415;
}
.main_left .title_num2 {
  background-color: #ff9933;
}
.main_left .title_num3 {
  background-color: #ffcc99;
}
.main_left .title_num4 {
  background-color: #cccccc;
}
.main_middle {
  float: left;
  padding-left: 0.35rem;
}
.course_title {
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.32rem;
  text-align: left;
  width: 4rem;
  overflow: hidden;
}
.course_time {
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.28rem;
  color: #999999;
  text-align: left;
}
.main_right {
  float: right;
}
.main_right_img {
  width: 1.8rem;
  height: 1rem;
}
.main_right_img img {
  width: 100%;
  height: 100%;
}
.video_btn {
  float: left;
  width: 1.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
  color: #ea5503;
  border: 1px solid #ea5503;
  border-radius: 10px 10px;
  background-color: #fff;
  font-size: 0.25rem;
  text-align: center;
  margin-top: 0.2rem;
}
.circle-chart {
  margin: 0.2rem 0.4rem 0;
}
.isactive {
  background-color: #f9f6f6;
}
.main_right_time {
  font-size: 0.28rem;
  padding-top: 0.8rem;
  color: #999999;
}
button:focus {
  outline: 0;
}
button {
  outline: none;
  -webkit-appearance: none;
  border: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
